export const getGenerateDietModalSteps = (t) => [
    {
        target: '[data-tour="gdm-modal"]',
        placement: 'center',
        title: t('tour.generateDietModal.step-welcome-title'),
        content: t('tour.generateDietModal.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="gdm-dates"]',
        title: t('tour.generateDietModal.step-dates-title'),
        content: t('tour.generateDietModal.step-dates-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="gdm-tabs"]',
        title: t('tour.generateDietModal.step-calories-title'),
        content: t('tour.generateDietModal.step-calories-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="gdm-footer"]',
        title: t('tour.generateDietModal.step-footer-title'),
        content: t('tour.generateDietModal.step-footer-content'),
        disableBeacon: true,
    },
];
